import { BlockerType } from 'game/boardMVC/types';

export interface LevelTask {
  type: LevelTaskType;
  amount: number;
}

export interface LevelTaskProgress {
  type: LevelTaskType;
  collected: number;
  goal: number;
}

export enum LevelTaskType {
  Hexes = 'Hexes',
  PlankBlockers = 'PlankBlockers',
  TapeBlockers = 'TapeBlockers',
  KnotBlockers = 'KnotBlockers',
  Birds = 'Birds',
  Stars = 'Stars',
  MeasureTape = 'MeasureTape',
  Rocket = 'Rocket',
  PlankRed = 'PlankRed',
  PlankGreen = 'PlankGreen',
  PlankBlue = 'PlankBlue',
  PlankPink = 'PlankPink',
  PlankYellow = 'PlankYellow',
  PlankGrey = 'PlankGrey',
  PlankWhite = 'PlankWhite',
  PlankNavy = 'PlankNavy',
  PlankPurple = 'Purple',
  PlankAny = 'PlankAny',
}

export const levelTaskToBlocker = new Map<LevelTaskType, BlockerType>([
  [LevelTaskType.PlankBlockers, BlockerType.Plank],
  [LevelTaskType.TapeBlockers, BlockerType.Tape],
  [LevelTaskType.KnotBlockers, BlockerType.Knot],
  [LevelTaskType.Birds, BlockerType.BirdHouse],
  [LevelTaskType.Rocket, BlockerType.Rocket],
  [LevelTaskType.MeasureTape, BlockerType.MeasureTape],
]);

export const dioramaFillConversion: Record<LevelTaskType, number> = {
  [LevelTaskType.Hexes]: 1,
  [LevelTaskType.PlankBlockers]: 11,
  [LevelTaskType.TapeBlockers]: 11,
  [LevelTaskType.KnotBlockers]: 11,
  [LevelTaskType.Birds]: 11,
  [LevelTaskType.Stars]: 11,
  [LevelTaskType.MeasureTape]: 11,
  [LevelTaskType.Rocket]: 11,
  [LevelTaskType.PlankRed]: 11,
  [LevelTaskType.PlankGreen]: 11,
  [LevelTaskType.PlankBlue]: 11,
  [LevelTaskType.PlankPink]: 11,
  [LevelTaskType.PlankYellow]: 11,
  [LevelTaskType.PlankGrey]: 11,
  [LevelTaskType.PlankWhite]: 11,
  [LevelTaskType.PlankNavy]: 11,
  [LevelTaskType.PlankPurple]: 11,
  [LevelTaskType.PlankAny]: 11,
};

export type LevelTaskTallies = Partial<Record<LevelTaskType, number>>;
